import React, {Component} from "react";
import PageTitle from "./PageTitle";
import {Link} from "react-router-dom";
import Scroll from 'react-scroll-to-element';

class PagePayments extends Component {

	state = {
		activeIndex : 0
	};

	setActiveItem(index) {
		const result = index === this.state.activeIndex ? 0 : index;
		this.setState({activeIndex : result});
	}

	render() {
		const classes_in = [
			{
				key   : 'Visa/MasterCard',
				value : 'visa-master'
			},
			{
				key   : 'Qiwi',
				value : 'qiwi'
			},
			{
				key   : 'ЕРИП',
				value : 'erip'
			},
			{
				key   : 'IPay',
				value : 'ipay'
			},
			{
				key   : 'ППС',
				value : 'pps'
			},
		];
		const classes_out = [
			{
				key   : 'ППС',
				value : 'out_pps'
			},
			{
				key   : 'Наличными в Белинвестбанке',
				value : 'belinvestbank'
			},
			{
				key   : 'Беларусбанк',
				value : 'belarusbank'
			},
			{
				key   : 'Белагропромбанк',
				value : 'belagro'
			},
			{
				key   : 'Приорбанк',
				value : 'priorbank'
			},
			{
				key   : 'БПС-Сбербанк',
				value : 'bps-bank'
			},
			{
				key   : 'Технобанк',
				value : 'techno-bank'
			},
			{
				key   : 'Белинвестбанк',
				value : 'belinvestbank'
			},
			{
				key   : 'Белвэб банк',
				value : 'belweb'
			},
			{
				key   : 'МТБанк',
				value : 'mtbank'
			},
			{
				key   : 'Белгазпромбанк',
				value : 'belgazprombank'
			},
			{
				key   : 'Банк Решение',
				value : 'bank-solution'
			},
			{
				key   : 'Паритетбанк',
				value : 'paritetbank'
			},
			{
				key   : 'Москва-Минск',
				value : 'moscow-minsk'
			},
		];

		const itemClass = 'payments__items__item';

		return (
			<div>
				<PageTitle text={'Способы пополнения игровых счетов'}/>

				<div className="page__data payments">

					<div className="payments__buttons">
						<div className="buttons payments__button">
							<Link to={'/user/pay'} className="buttons__show">Пополнить счет</Link>
						</div>

						<div className="buttons payments__button">
							<Link to={'/user/take-money'} className="buttons__show gray">Снять деньги</Link>
						</div>
					</div>

					{/*<div className="payments__tags">*/}
					{/*<div className="buttons payments__buttons">*/}
					{/*<Link to={'/user/pay'} className="buttons__show">Пополнить счет</Link>*/}
					{/*</div>*/}
					{/*<ul>*/}
					{/*{classes_in.map((item) =>*/}
					{/*<li>*/}
					{/*<Scroll type="class" element={item.value}>*/}
					{/*{item.key}*/}
					{/*</Scroll>*/}
					{/*</li>*/}
					{/*)}*/}
					{/*</ul>*/}
					{/*</div>*/}

					{/*<div className="payments__tags">*/}
					{/*<div className="buttons payments__buttons">*/}
					{/*<Link to={'/user/take-money'} className="buttons__show gray">Снять деньги</Link>*/}
					{/*</div>*/}
					{/*<ul>*/}
					{/*{classes_out.map((item) =>*/}
					{/*<li>*/}
					{/*<Scroll type="class" element={item.value}>*/}
					{/*{item.key}*/}
					{/*</Scroll>*/}
					{/*</li>*/}
					{/*)}*/}
					{/*</ul>*/}
					{/*</div>*/}

					<div className="payments__items">
						{/*<div className={`${itemClass} ${this.state.activeIndex === 1 ? 'active' : ''}`} onClick={this.setActiveItem.bind(this, 1)}>*/}
							{/*<div className="title visa-master">*/}
								{/*<p>Visa/Mastercard</p>*/}
							{/*</div>*/}
							{/*<div className="hidden">*/}
								{/*<p>*/}
									{/*Вы должны зайти в раздел нашего сайта <Link to={'/user/pay'}>«Пополнить счёт»</Link>,*/}
									{/*сформировать счёт для оплаты в системе iPay (с указанием суммы платежа) через*/}
									{/*банковскую карту и подтвердить его. После*/}
									{/*чего произойдёт перенаправление на защищенную страницу оплаты, где Вы должны будете*/}
									{/*заполнить данные о своей банковской карте. Затем введите пароль «3-D Secure»*/}
									{/*(получение*/}
									{/*посредством интернет-банкинга или через SMS на привязанный к карте номер мобильного*/}
									{/*телефона).*/}
								{/*</p>*/}
							{/*</div>*/}
							{/*<div className="warning hidden">*/}
								{/*<div className="warning-title">Внимание!</div>*/}
								{/*<p>*/}
									{/*Карта, при помощи которой Вы желаете пополнить игровой счет, должна быть изготовлена*/}
									{/*банком Республики Беларусь. Кроме того, используется технология <strong>"3-D*/}
									{/*Secure"</strong>.*/}
								{/*</p>*/}
								{/*<ul>*/}
									{/*<li>Минимальная сумма - 2 руб.;</li>*/}
									{/*<li>Комиссия - 0%;</li>*/}
									{/*<li>Время зачисления на игровой счёт - 5 минут.</li>*/}
								{/*</ul>*/}
							{/*</div>*/}
						{/*</div>*/}

						{/*<div className={`${itemClass} ${this.state.activeIndex === 2 ? 'active' : ''}`} onClick={this.setActiveItem.bind(this, 2)}>*/}
							{/*<div className="title qiwi">*/}
								{/*<p>Qiwi-терминал</p>*/}
							{/*</div>*/}
							{/*<div className="hidden">*/}
								{/*<p>*/}
									{/*Вы можете пополнить свой игровой счет с помощью Qiwi терминала. Вам следует войти в*/}
									{/*раздел "Оплата услуг", затем Вы переходите в "Букмекеры, игры и лотереи", далее*/}
									{/*выбираем "Maxline". В открывшемся окне вам следует ввести номер вашего игрового*/}
									{/*счета. Далее нажимаете клавишу "Вперед". Вам осталось лишь вставить купюры в*/}
									{/*купюроприемник и подтвердить указанную сумму.*/}
								{/*</p>*/}
								{/*<p>*/}
									{/*<a href="https://www.youtube.com/watch?v=71wlaZSGayg" target="_blank">Видеоинструкция</a>*/}
								{/*</p>*/}
							{/*</div>*/}
						{/*</div>*/}

						{/*<div className={`${itemClass} ${this.state.activeIndex === 3 ? 'active' : ''}`} onClick={this.setActiveItem.bind(this, 3)}>*/}
							{/*<div className="title erip">*/}
								{/*<p>«Расчет» (ЕРИП)</p>*/}
							{/*</div>*/}
							{/*<div className="hidden">*/}
								{/*<p>Вы можете оплачивать услуги в 27 банках Республики Беларусь, воспользоваться свыше*/}
									{/*15553*/}
									{/*пунктов банковского обслуживания: кассы банка, банкоматы, инфокиоски, устройства*/}
									{/*приема*/}
									{/*наличных денег (cash-in). Наибольшие удобства система «Расчет» создает для*/}
									{/*пользователей*/}
									{/*Интернет-банка и для систем электронных денег.*/}
								{/*</p>*/}
							{/*</div>*/}
							{/*<div className="hidden">*/}
								{/*<p>Игровой счёт можно пополнить в пунктах банковского обслуживания:</p>*/}
								{/*<ul>*/}
									{/*<li>ОАО «Белагропромбанк»</li>*/}
									{/*<li>«Приорбанк» ОАО</li>*/}
									{/*<li>ОАО «БПС-Сбербанк»</li>*/}
									{/*<li>ОАО «Белинвестбанк»</li>*/}
									{/*<li>ОАО «Технобанк»</li>*/}
									{/*<li>ОАО «Паритетбанк»</li>*/}
									{/*<li>ОАО «Белгазпромбанк»</li>*/}
									{/*<li>ЗАО «Идея Банк»</li>*/}
									{/*<li>ЗАО «РРБ-Банк»</li>*/}
									{/*<li>ЗАО «МТБанк»</li>*/}
									{/*<li>ЗАО «Трастбанк»</li>*/}
									{/*<li>ЗАО «Дельта Банк»</li>*/}
									{/*<li>ОАО «Банк БелВЭБ»</li>*/}
									{/*<li>ЗАО «ИнтерПэйБанк»</li>*/}
									{/*<li>ЗАО «БТА Банк»</li>*/}
									{/*<li>ОАО «АСБ Беларусбанк»</li>*/}
									{/*<li>ОАО «Банк Москва-Минск»</li>*/}
									{/*<li>ОАО «Хоум Кредит Банк»</li>*/}
									{/*<li>ЗАО «Банк ВТБ» (Беларусь)</li>*/}
									{/*<li>ОАО «БНБ-Банк»</li>*/}
									{/*<li>«Франсабанк» ОАО</li>*/}
									{/*<li>ЗАО «Евробанк»</li>*/}
									{/*<li>ЗАО «Цептер Банк»</li>*/}
									{/*<li>ЗАО «АБСОЛЮТБАНК»</li>*/}
									{/*<li>ЗАО «БСБ Банк»</li>*/}
									{/*<li>ЗАО «Альфа-Банк»</li>*/}
									{/*<li>«Евроторгинвестбанк» ОАО</li>*/}
								{/*</ul>*/}
								{/*<div className="note">*/}
									{/*<div>*/}
										{/*При пополнении игрового счета платежной карточкой или наличными деньгами в кассе*/}
										{/*одного*/}
										{/*из вышеперечисленных банков.*/}
										{/*Вы должны сообщить кассиру о необходимости проведения оплаты услуги «maxline.by*/}
										{/*-*/}
										{/*Ставки» через систему «Расчет» (ЕРИП),*/}
										{/*а затем назвать:*/}
									{/*</div>*/}
									{/*<ul>*/}
										{/*<li>Номер вашего игрового счета на нашем сайте;</li>*/}
										{/*<li>Фамилию, И.О.;</li>*/}
										{/*<li>Сумму.</li>*/}
									{/*</ul>*/}
								{/*</div>*/}
								{/*<h4>Инфокиоски, банкоматы, WebMoney, iPay, BelQI</h4>*/}
								{/*<p>В разделе "Платежи" выберите пункты: Система "Расчет" (ЕРИП), затем*/}
									{/*"Интернет-магазины /*/}
									{/*сервисы - Букмекерские конторы - Maxline.by ставки".</p>*/}
								{/*<p>Ведите номер Вашего игрового счета и сумму.</p>*/}

								{/*<ul>*/}
									{/*<li>Минимальная сумма - 0.50 руб.;</li>*/}
									{/*<li>Комиссия - 0%;</li>*/}
									{/*<li>Время зачисления на игровой счёт - 5 минут.</li>*/}
								{/*</ul>*/}
							{/*</div>*/}
						{/*</div>*/}

						{/*<div className={`${itemClass} ${this.state.activeIndex === 4 ? 'active' : ''}`} onClick={this.setActiveItem.bind(this, 4)}>*/}
							{/*<div className="title ipay">*/}
								{/*<p>iPay</p>*/}
							{/*</div>*/}
							{/*<div className="hidden">*/}
								{/*<p>*/}
									{/*Для оплаты с мобильного телефона отправьте СМС-сообщение на номер 553 с текстом:*/}
									{/*750 &lt;Номер счета&gt;&nbsp;&lt;Сумма платежа&gt; Пример СМС-сообщения: "750 10001*/}
									{/*1".*/}

								{/*</p>*/}

								{/*<div className="note">*/}
									{/*Обратите внимание:*/}

									{/*<ol>*/}
										{/*<li>*/}
											{/*Разделитель между параметрами в СМС - символ пробела;*/}
											{/*Сумма заказа будет списана с баланса мобильного телефона;*/}
											{/*По правилам системы iPay после оплаты на Вашем балансе должно остаться не*/}
											{/*менее 0.10*/}
											{/*бел. руб. для абонентов МТС и Velcom, не менее 0.50 бел. руб. - для*/}
											{/*абонентов*/}
											{/*life:);*/}
											{/*Отправка СМС на номер 553 бесплатна для абонентов МТС и life:), с абонентов*/}
											{/*Velcom*/}
											{/*взымается плата в размере 0.10 бел. руб.;*/}
										{/*</li>*/}
										{/*<li>*/}
											{/*Для оплаты через сайт системы iPay для абонентов МТС перейдите на сайт iPay*/}
											{/*по*/}
											{/*ссылке <a href="https://mts.ipay.by:4443/pls/iPay/!iSOU.Login?srv_no=19533">ipay.by</a>*/}
										{/*</li>*/}
										{/*<li>*/}
											{/*Для оплаты через сайт системы iPay для абонентов life:) перейдите на сайт*/}
											{/*iPay по*/}
											{/*ссылке <a href="http://gate.besmart.by/ipaylife/!iSOU.Login?srv_no=19533&opt=1">ipay.by</a>*/}
										{/*</li>*/}
										{/*<li>*/}
											{/*Для оплаты через сайт системы iPay для абонентов Velcom перейдите на сайт*/}
											{/*iPay по*/}
											{/*ссылке <a href="https://velcom.ipay.by/ipay_velcom/!iSOU.Login?srv_no=19533">ipay.by</a>*/}
										{/*</li>*/}
									{/*</ol>*/}

									{/*<p>*/}
										{/*Для оплаты через сайт системы iPay после входа в личный кабинет в разделе*/}
										{/*"Перечень*/}
										{/*услуг" выберите систему "Расчет" (ЕРИП), затем "Интернет-магазины / сервисы" и в*/}
										{/*алфавите на букву "M" выберите "maxline.by - Ставки". Введите номер Вашего*/}
										{/*игрового*/}
										{/*счета и сумму.*/}
									{/*</p>*/}
									{/*<p>Минимальная сумма - 0.50 руб.;</p>*/}
									{/*<p>Минимальная сумма - 0.50 руб.;</p>*/}
								{/*</div>*/}
							{/*</div>*/}
						{/*</div>*/}

						<div className={`${itemClass} ${this.state.activeIndex === 5 ? 'active' : ''}`} onClick={this.setActiveItem.bind(this, 5)}>
							<div className="title pps">
								<p>Пункты приёма ставок</p>
							</div>
							<div className="hidden">
								<p>
									Игровой счет на сайте будет пополнен моментально.
								</p>
								<p>
									{/*Минимальная сумма - 1.00 руб.;*/}
									Комиссия - 0%;
									Время зачисления на игровой счёт - моментально.
								</p>
								<div className="note">
									Список ППС:
									<ul>
										<li>г. Исфара ул.Марказй 17 (ориентир напротив кинотеатра Мубораккадам)</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>

				<PageTitle text={'Способы получения выигрыша'}/>

				<div className="page__data payments">
					<div className="payments__items">
						<div className={`${itemClass} ${this.state.activeIndex === 6 ? 'active' : ''}`}
						     onClick={this.setActiveItem.bind(this, 6)}>
							<div className="title pps out_pps">
								<p>Пункты приёма ставок</p>
							</div>
							<div className="hidden">
								<p>
									Для получения выигрыша клиент должен сделать заказ на получение денег на сайте
									букмекерской конторы. Получить заказанную сумму можно в пунктах приемах ставок,
									указанных на сайте сразу после подтверждения заказа. При получении денег необходимо
									предъявить паспорт.
								</p>
							</div>
							<div className="hidden">
								<p>Минимальная сумма - 1.00 руб.;</p>
								<p>Комиссия - 0%;</p>
								<p>Время зачисления - 24 часа.</p>

								<div className="note">
									Список ППС:
									<ul>
										<li>г. Исфара ул.Марказй 17 (ориентир напротив кинотеатра Мубораккадам)</li>
									</ul>
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default PagePayments;


// WEBPACK FOOTER //
// ./src/app/pages/Page/PagePayments.js